export default function initials(name: string = ''): string {
  return name.replace(/[a-z]|\s/g, '');
}
